
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute: React.FC<{
  element: React.ReactNode;
  permissions?: string[];
}> = ({ element, permissions }) => {
  const authService = useAuth();
  
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;



// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// const ProtectedRoute: React.FC<{
//   element: React.ReactNode;
//   permissions?: string[];
// }> = ({ element, permissions }) => {
//   const authService = useAuth();

//   if (permissions && !authService.hasPermission(permissions)) {
//     return authService.isAuthenticated() ? (
//       <Navigate to="/access-denied" replace />
//     ) : (
//       <Navigate to="/login" replace />
//     );
//   }

//   return <>{element}</>;
// };

// export default ProtectedRoute;
